import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import Slidebar from './Slidebar';
import { logout } from '../Redux/user_information';
import '../Styles/AdminLaout.css';

const AdminLayout = () => {
  const [isSidebarCompact, setIsSidebarCompact] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { token, loginData } = useSelector((state) => state.user);

  const isLoggedIn = !!token;
  const userRole = loginData?.user?.role || loginData?.role || 'admin';
  const isAdmin = userRole?.toLowerCase() === 'admin';
  const isFreelancer = userRole?.toLowerCase() === 'freelancer';

  const rolePermissions = {
    admin: [
      'dashboard', 'customers', 'drivers', 'conductors', 'bus-owners','bus-report',
      'employees', 'routes', 'bookings', 'payments', 'coupons',
      'influencers', 'owner-commissions', 'profit-report', 'influencer-commissions',
      'seat-management', 'profile', 'terms', 'chart', 'freelancers', 'expenses-report','view-routes', 
      'GSTAdminPanel', 'masterroutes', 'GSTManagement', 'master-routes', 'gst-management', 'customer-care','versions',
      'gst-admin-panel', 'bus-fare-chart',"platform-management",'BusManagement','BookingPolicyManagement','busroutes','bus-owner-report'
    ],
    freelancer: [
      'dashboard', 'drivers', 'conductors', 'bus-owners', 'routes', 'profile'
    ]
  };

  const getAllowedMenus = () => {
    if (isAdmin) return rolePermissions.admin;
    if (isFreelancer) return rolePermissions.freelancer;
    return ['dashboard', 'profile'];
  };

  const allowedMenus = getAllowedMenus();

  const hasAccessToRoute = (path) => {
    const currentMenu = path.substring(1) || 'dashboard';
    return allowedMenus.includes(currentMenu);
  };

  useEffect(() => {
    if (isLoggedIn && !hasAccessToRoute(location.pathname)) {
      navigate('/dashboard');
    }
  }, [location.pathname, isLoggedIn, navigate]);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const getUserDisplayName = () => {
    if (loginData?.user?.name) return loginData.user.name;
    if (loginData?.name) return loginData.name;
    if (loginData?.user?.email) return loginData.user.email;
    if (loginData?.email) return loginData.email;
    return 'User';
  };

  const getRoleBadgeStyle = () => {
    if (isAdmin) {
      return {
        backgroundColor: '#28a745',
        color: 'white',
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600',
        marginRight: '15px'
      };
    }
    if (isFreelancer) {
      return {
        backgroundColor: '#ffc107',
        color: '#212529',
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600',
        marginRight: '15px'
      };
    }
    return {
      backgroundColor: '#6c757d',
      color: 'white',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      marginRight: '15px'
    };
  };

  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className="admin-layout">
      <Slidebar
        activeMenu={location.pathname.substring(1) || 'dashboard'}
        setActiveMenu={(menu) => navigate(`/${menu}`)}
        onToggleCompact={setIsSidebarCompact}
        userRole={userRole}
        allowedMenus={allowedMenus}
        isAdmin={isAdmin}
        isFreelancer={isFreelancer}
      />

      <main className={`admin-main ${isSidebarCompact ? 'compact-sidebar' : ''}`}>
        <header className="admin-header" style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: '0 30px',
          height: '70px',
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          position: 'sticky',
          top: 0,
          zIndex: 100
        }}>
          <div className="header-right" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px'
          }}>

            <span style={getRoleBadgeStyle()}>
              {isAdmin ? '👑 Admin' : isFreelancer ? '🔧 Freelancer' : '👤 User'}
            </span>


            <div className="user-profile" style={{
              position: 'relative'
            }}>
              <div className="profile-dropdown" style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  color: '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  {getUserDisplayName()}
                </span>
                <button
                  className="profile-btn"
                  onClick={() => navigate('/profile')}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '4px',
                    color: '#333',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#e9ecef';
                    e.target.style.borderColor = '#ced4da';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.borderColor = '#dee2e6';
                  }}
                >
                  Profile
                </button>
                <button
                  className="logout-btn"
                  onClick={handleLogout}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#dc3545',
                    border: 'none',
                    borderRadius: '4px',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </header>

        <div className="content-wrapper" style={{
          padding: '30px',
          backgroundColor: '#f8f9fa',
          minHeight: 'calc(100vh - 70px)'
        }}>
          <Outlet /> 
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;